'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  cursor: pointer;\n'], ['\n  cursor: pointer;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: ', ';\n'], ['\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n  padding-top: ', ';\n'], ['\n  position: relative;\n  padding-top: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: inline-block;\n  cursor: default;\n  right: ', ';\n  bottom: ', ';\n  width: ', ';\n'], ['\n  display: inline-block;\n  cursor: default;\n  right: ', ';\n  bottom: ', ';\n  width: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _pclnDesignSystem = require('pcln-design-system');

var _sizeMap = require('../../../helpers/sizeMap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  className: _propTypes2.default.string,
  disclaimerMessageTitle: _propTypes2.default.string,
  disclaimerMessage: _propTypes2.default.string,
  size: _propTypes2.default.string,
  disclaimerTitleSize: _propTypes2.default.number,
  disclaimerTextSize: _propTypes2.default.number,
  tooltipPositionX: _propTypes2.default.string,
  tooltipPositionY: _propTypes2.default.string,
  tooltipPositionCenter: _propTypes2.default.string,
  color: _propTypes2.default.string,
  iconName: _propTypes2.default.string,
  isCustomTooltipOpen: _propTypes2.default.bool,
  customTooltip: _propTypes2.default.node,
  hoverStyle: _propTypes2.default.bool
};

var defaultProps = {
  disclaimerTitleSize: 1,
  disclaimerTextSize: 0,
  tooltipPositionX: 'right',
  tooltipPositionY: 'bottom',
  iconName: 'informationOutline',
  hoverStyle: false
};

var Disclaimer = function (_Component) {
  _inherits(Disclaimer, _Component);

  function Disclaimer(props) {
    _classCallCheck(this, Disclaimer);

    var _this = _possibleConstructorReturn(this, (Disclaimer.__proto__ || Object.getPrototypeOf(Disclaimer)).call(this, props));

    _this.state = {
      disclaimerOpened: false
    };
    _this._toggleDisclaimer = _this.toggleDisclaimer.bind(_this);
    _this._closeDisclaimer = _this.closeDisclaimer.bind(_this);
    return _this;
  }

  _createClass(Disclaimer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this._closeDisclaimer);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this._closeDisclaimer);
    }
  }, {
    key: 'toggleDisclaimer',
    value: function toggleDisclaimer(e) {
      if (this.props.customTooltip) return;

      e.stopPropagation();
      this.setState({
        disclaimerOpened: !this.state.disclaimerOpened
      });
    }
  }, {
    key: 'closeDisclaimer',
    value: function closeDisclaimer(e) {
      if (!this.state.disclaimerOpened || !this.root || this.root.contains(e.target)) {
        return;
      }
      this.setState({
        disclaimerOpened: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          size = _props.size,
          color = _props.color,
          disclaimerTitleSize = _props.disclaimerTitleSize,
          disclaimerTextSize = _props.disclaimerTextSize,
          disclaimerMessage = _props.disclaimerMessage,
          disclaimerMessageTitle = _props.disclaimerMessageTitle,
          tooltipPositionX = _props.tooltipPositionX,
          tooltipPositionY = _props.tooltipPositionY,
          tooltipPositionCenter = _props.tooltipPositionCenter,
          iconName = _props.iconName,
          isCustomTooltipOpen = _props.isCustomTooltipOpen,
          customTooltip = _props.customTooltip,
          hoverStyle = _props.hoverStyle;


      var openDisclaimer = hoverStyle ? true : this.state.disclaimerOpened;

      return _react2.default.createElement(
        DisclaimerWrap,
        { innerRef: function innerRef(node) {
            return _this2.root = node;
          }, className: className },
        !hoverStyle && _react2.default.createElement(PaddedIcon, {
          'data-unit-id': 'disclaimer-icon',
          onClick: this._toggleDisclaimer,
          size: _sizeMap.strikePriceSizeMap[size][0],
          name: iconName,
          color: color,
          isLarge: size === 'large'
        }),
        openDisclaimer && !customTooltip && _react2.default.createElement(
          StyledBox,
          { top: tooltipPositionY === 'top' },
          _react2.default.createElement(
            StyledTooltip,
            {
              zIndex: 2,
              color: hoverStyle ? 'white' : 'text',
              bg: hoverStyle ? 'gray' : 'lightGray',
              left: tooltipPositionX === 'left',
              right: tooltipPositionX === 'right',
              bottom: tooltipPositionY === 'bottom',
              top: tooltipPositionY === 'top',
              center: tooltipPositionCenter === 'center',
              textAlign: 'left',
              align: 'left',
              isWide: hoverStyle
            },
            _react2.default.createElement(
              _pclnDesignSystem.Flex,
              {
                justifyContent: 'space-between',
                justify: 'space-between'
              },
              _react2.default.createElement(
                _pclnDesignSystem.Text,
                {
                  textAlign: 'left',
                  align: 'left',
                  bold: true,
                  fontWeight: 'bold',
                  fontSize: disclaimerTitleSize
                },
                disclaimerMessageTitle
              ),
              !hoverStyle && _react2.default.createElement(_pclnDesignSystem.CloseButton, {
                size: _sizeMap.strikePriceSizeMap[size][0],
                onClick: this._toggleDisclaimer,
                color: 'text'
              })
            ),
            _react2.default.createElement(
              _pclnDesignSystem.Text,
              {
                textAlign: 'left',
                align: 'left',
                fontSize: disclaimerTextSize
              },
              disclaimerMessage
            )
          )
        ),
        isCustomTooltipOpen && customTooltip
      );
    }
  }]);

  return Disclaimer;
}(_react.Component);

var DisclaimerWrap = _styledComponents2.default.span(_templateObject);

var StyledBox = (0, _styledComponents2.default)(_pclnDesignSystem.Box)(_templateObject2, function (props) {
  return props.top ? '0' : 'unset';
});

var PaddedIcon = (0, _styledComponents2.default)(_pclnDesignSystem.Icon)(_templateObject3, function (props) {
  return props.isLarge ? '4px' : '2px';
});

var StyledTooltip = (0, _styledComponents2.default)(_pclnDesignSystem.Tooltip)(_templateObject4, function (props) {
  return props.isWide ? 'calc(50% - 28px)' : '0';
}, function (props) {
  return props.isWide ? '-4px' : 'auto';
}, function (props) {
  return props.isWide ? '240px' : 'auto';
});

Disclaimer.propTypes = propTypes;
Disclaimer.defaultProps = defaultProps;

exports.default = Disclaimer;